import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from "react-redux";
import { BillingIntervalButtons } from "./BillingIntervalButtons";
import ProductCard from "./ProductCard";
import { fetchPlans } from "../../actions/products";
import fetchLoginStatus from "../util/login-status";

const Wrap = styled.div`
    font-family: "Inter", system-ui, sans-serif;
    padding-bottom: 60px;
`;

const Hero = styled.div`
    text-align: center;
    padding: 32px 0 40px;
`;

const HeroTitle = styled.h1`
    margin: 0 0 12px;
    font-size: clamp(1.8rem, 4vw, 2.6rem);
    font-weight: 800;
    color: #0f172a;
    letter-spacing: -0.5px;
`;

const HeroSub = styled.p`
    margin: 0 auto;
    max-width: 480px;
    font-size: 1rem;
    color: #64748b;
    line-height: 1.6;
`;

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    @media (max-width: 1024px) { grid-template-columns: repeat(2, 1fr); }
    @media (max-width: 600px)  { grid-template-columns: 1fr; }
`;

export default function Pricing() {
    const [priceInterval, setPriceInterval] = useState("month");
    const dispatch   = useDispatch();
    const login      = useSelector(s => s.login);
    const isLoggedIn = useSelector(s => s.login.userDetails.isLoggedIn);
    const plans      = useSelector(s => s.plans);

    useEffect(() => {
        if (!plans.fetched) dispatch(fetchPlans());
        if (!login.userDetails.fetchAttempted) dispatch(fetchLoginStatus(login));
    }, [login, dispatch, plans.fetched]);

    function handlePriceIntervalChange(e, newInterval) {
        if (newInterval) setPriceInterval(newInterval);
    }

    return (
        <Wrap>
            <Hero>
                <HeroTitle>
                    {isLoggedIn ? "Change your plan" : "Simple, transparent pricing"}
                </HeroTitle>
                <HeroSub>
                    {isLoggedIn
                        ? "Switch plans at any time. Unused time on your current plan will be credited."
                        : "Pick the plan that fits your needs. Upgrade or downgrade at any time."}
                </HeroSub>
            </Hero>

            <BillingIntervalButtons
                priceInterval={priceInterval}
                handlePriceIntervalChange={handlePriceIntervalChange}
            />

            <Grid>
                {plans.data.map((product, i) => (
                    <ProductCard
                        key={i}
                        product={product}
                        priceInterval={priceInterval}
                    />
                ))}
            </Grid>
        </Wrap>
    );
}
